import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DatePipe } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-range-datepicker',
  templateUrl: './range-datepicker.component.html',
  styleUrls: ['./range-datepicker.component.scss']
})
export class RangeDatepickerComponent implements OnInit,OnDestroy {
  range:FormGroup;
  today=new Date();
  startDate;
  selectedValue:string='Last 30 days';
  @Input() isGraphDataChange=true;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  private destroy$ = new Subject<void>();

  constructor(private dashboardService:DashboardService,private datepipe:DatePipe) { }

  ngOnInit(): void {
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
    this.setDate(this.selectedValue);
  }

  dateRangeChange(dateRangeStart, dateRangeEnd) {
    if(dateRangeStart.value && dateRangeEnd.value){
      let start=new Date(dateRangeStart.value);
      let end=new Date(dateRangeEnd.value);
      const startDate=this.datepipe.transform(start, 'MM/dd/yy');
      const endDate=this.datepipe.transform(end, 'MM/dd/yy');
      this.selectedValue=startDate+ ' - ' +endDate;
      this.dashboardService.selectedDate$.next({startDate:start.toDateString(),endDate:end.toDateString(),selected:this.selectedValue,isGraphDataChange:this.isGraphDataChange});
      this.trigger.closeMenu(); 
    }
  }

  setDate(value){
    this.selectedValue=value;
    switch (value) {
      case "Last 7 days":        
        this.startDate = new Date(new Date().setDate(this.today.getDate() - 7));        
        break;
      case "Last 15 days":
        this.startDate = new Date(new Date().setDate(this.today.getDate() - 15));
        break;
      case "Last 30 days":       
       this.startDate = new Date(new Date().setDate(this.today.getDate() - 30));
        break;
      case "Last 3 months":
        this.startDate = new Date(new Date().setMonth(this.today.getMonth() - 3));
        break;
      case "Last 6 months":
        this.startDate = new Date(new Date().setMonth(this.today.getMonth() - 6));
        break;
      case "Last 12 months":
        this.startDate = new Date(new Date().setFullYear(this.today.getFullYear() - 1));
        break;
      default:
        this.startDate = new Date(new Date().setDate(this.today.getDate() - 30));       
        break;
    }
    this.dashboardService.selectedDate$.next({startDate:this.startDate.toDateString(),endDate:this.today.toDateString(),selected:this.selectedValue,isGraphDataChange:this.isGraphDataChange});
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
